(() => {
  if (window.__snugAdvancedMenuLoaded) return;
  window.__snugAdvancedMenuLoaded = true;

  const desktop = () => window.matchMedia('(min-width: 1025px)').matches;

  const categoryMarkup = [
    ['/collections/chenille-sofa-covers', '🛋️', 'Sofa Covers', 'Pet-friendly comfort and protection'],
    ['/collections/cushions-and-cushion-covers', '◫', 'Cushions & Covers', 'Easy layers for a softer home'],
    ['/collections/floor-carpets', '▦', 'Rugs & Floor Mats', 'Warmth and texture underfoot'],
    ['/collections/peel-and-stick-wallpaper', '▤', 'Wall Art and Wallpapers', 'Refresh a room without renovation'],
    ['/collections/artificial-plants', '🌿', 'Artificial Plants', 'Evergreen style, no maintenance']
  ].map(([url, icon, title, copy]) => `
    <a class="snug-mega__category" href="${url}">
      <span class="snug-mega__icon" aria-hidden="true">${icon}</span>
      <span><strong>${title}</strong><small>${copy}</small></span>
      <span class="snug-mega__arrow" aria-hidden="true">→</span>
    </a>`).join('');

  const megaMarkup = `
    <div class="snug-mega__content">
      <span class="snug-mega__eyebrow">Shop for Australian homes</span>
      <h2 class="snug-mega__heading">Comfort, protection and effortless style</h2>
      <p class="snug-mega__intro">Explore practical home updates selected for everyday Australian living.</p>
      <div class="snug-mega__categories">${categoryMarkup}</div>
      <div class="snug-mega__trust" aria-label="Shopping benefits">
        <span>🇦🇺 Australia-wide delivery</span>
        <span>✓ Prices in AUD</span>
        <span>🔒 Secure checkout</span>
      </div>
    </div>`;

  function setAccessibleLabels(scope) {
    scope.querySelectorAll('[arial-label]').forEach((element) => {
      if (!element.hasAttribute('aria-label')) {
        element.setAttribute('aria-label', element.getAttribute('arial-label'));
      }
    });

    const close = scope.querySelector('close-menu.close-menu');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close menu');
    }
  }

  function initialise(nav) {
    if (!nav || nav.dataset.snugAdvanced === 'true') return;
    nav.dataset.snugAdvanced = 'true';
    setAccessibleLabels(nav);

    const list = nav.querySelector('.horizontal-list');
    if (!list) return;

    const links = [...list.querySelectorAll(':scope > li > menu-item > a')];
    const shopLink = links.find((link) => {
      const path = new URL(link.href, location.origin).pathname.replace(/\/$/, '');
      return path === '/collections' || link.textContent.trim().toLowerCase() === 'all products';
    });

    if (shopLink) {
      const parent = shopLink.closest('li.level0');
      parent.classList.add('snug-shop-parent');
      shopLink.setAttribute('aria-label', 'Shop product categories');
      shopLink.setAttribute('aria-haspopup', 'true');
      shopLink.setAttribute('aria-expanded', 'false');
      shopLink.setAttribute('aria-controls', 'snug-shop-mega-menu');
      shopLink.innerHTML = '<span>Shop</span><svg class="snug-nav-chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const panel = document.createElement('div');
      panel.id = 'snug-shop-mega-menu';
      panel.className = 'snug-mega-menu';
      panel.setAttribute('aria-label', 'Shop categories');
      panel.innerHTML = megaMarkup;
      parent.appendChild(panel);

      const open = (focusFirst = false) => {
        parent.classList.add('snug-open');
        shopLink.setAttribute('aria-expanded', 'true');
        if (focusFirst) {
          window.setTimeout(() => panel.querySelector('a')?.focus(), 30);
        }
      };
      const close = (returnFocus = false) => {
        parent.classList.remove('snug-open');
        shopLink.setAttribute('aria-expanded', 'false');
        if (returnFocus) shopLink.focus();
      };

      let closeTimer;
      const cancelClose = () => {
        window.clearTimeout(closeTimer);
      };
      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => close(), 320);
      };

      shopLink.addEventListener('click', (event) => {
        event.preventDefault();
        if (desktop()) {
          cancelClose();
          open();
        } else {
          parent.classList.contains('snug-open') ? close() : open();
        }
      });

      shopLink.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();
          open(true);
        }
      });

      shopLink.addEventListener('keyup', (event) => {
        if (['ArrowDown', 'Escape', 'Enter', ' '].includes(event.key)) {
          event.stopPropagation();
        }
      });

      parent.addEventListener('mouseenter', () => {
        if (desktop()) {
          cancelClose();
          open();
        }
      });
      parent.addEventListener('mouseleave', () => {
        if (desktop()) scheduleClose();
      });

      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', () => {
        if (desktop()) scheduleClose();
      });

      parent.addEventListener('focusout', (event) => {
        if (desktop() && !parent.contains(event.relatedTarget)) close();
      });

      document.addEventListener('click', (event) => {
        if (!parent.contains(event.target)) {
          cancelClose();
          close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && parent.classList.contains('snug-open')) {
          close(true);
        }
      });

      window.addEventListener('resize', () => {
        cancelClose();
        close();
      }, { passive: true });
      nav.querySelectorAll('close-menu.close-menu').forEach((button) => {
        button.addEventListener('click', () => close());
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            button.click();
          }
        });
      });
    }

    const finderLink = links.find((link) => link.textContent.toLowerCase().includes('sofa cover finder'));
    if (finderLink && !finderLink.querySelector('.snug-nav-badge')) {
      finderLink.insertAdjacentHTML('beforeend', '<span class="snug-nav-badge">Find your fit</span>');
    }

    const accountLink = list.querySelector('.account-login');
    if (accountLink) accountLink.setAttribute('aria-label', 'Login or create an account');

    const categories = nav.querySelectorAll('.categories-menu-items-link');
    const categoryIcons = ['🛋️', '▤', '▦', '◫', '🌿'];
    categories.forEach((link, index) => {
      if (!link.querySelector('.snug-category-icon')) {
        link.insertAdjacentHTML('afterbegin', `<span class="snug-category-icon" aria-hidden="true">${categoryIcons[index] || '⌂'}</span>`);
      }
    });

    const trust = document.createElement('div');
    trust.className = 'snug-mobile-trust';
    trust.setAttribute('aria-label', 'Australian shopping information');
    trust.innerHTML = '<span>🇦🇺 Free delivery Australia-wide</span><span>✓ Prices displayed in AUD</span><span>🔒 Secure Shopify checkout</span><span>📏 Product sizing in centimetres</span>';
    nav.querySelector('.navigation__menu-content')?.appendChild(trust);
  }

  function initialiseHeaderActions() {
    document.querySelectorAll('.minicart__action').forEach((cartAction) => {
      if (cartAction.dataset.snugCartTrigger === 'true') return;
      cartAction.dataset.snugCartTrigger = 'true';
      cartAction.setAttribute('aria-label', 'Open shopping cart');

      cartAction.addEventListener('click', () => {
        document.querySelectorAll('header-search .popup-search-form').forEach((popup) => {
          popup.classList.remove('popup-search-show');
          popup.classList.add('search-hidden');
          popup.setAttribute('aria-hidden', 'true');
        });
        document.getElementById('snug-mobile-search-sheet')?.classList.remove('is-open');
        const mobileSearchSheet = document.getElementById('snug-mobile-search-sheet');
        if (mobileSearchSheet) mobileSearchSheet.hidden = true;
        document.documentElement.classList.remove('open-search', 'snug-search-open', 'snug-mobile-search-active');
        document.body.classList.remove('snug-search-open', 'snug-mobile-search-active');
        const drawer = document.querySelector('.minicart__wrapper');
        if (!drawer || !document.documentElement.classList.contains('open-minicart')) return;
        document.documentElement.classList.add('open-drawer');
        drawer.classList.add('open');
        drawer.classList.remove('invisible');
      });
    });

    document.querySelectorAll('.close-cart-button').forEach((closeButton) => {
      closeButton.setAttribute('aria-label', 'Close shopping cart');
    });

    const closeCart = () => {
      document.documentElement.classList.remove('open-drawer', 'open-minicart');
      document.body.classList.remove('open-drawer', 'open-minicart');
      const drawer = document.querySelector('.minicart__wrapper');
      drawer?.classList.remove('open');
      window.setTimeout(() => {
        if (!document.documentElement.classList.contains('open-minicart')) {
          drawer?.classList.add('invisible');
        }
      }, 320);
    };

    if (document.documentElement.dataset.snugCartCloseDelegate !== 'true') {
      document.documentElement.dataset.snugCartCloseDelegate = 'true';
      document.addEventListener('click', (event) => {
        const closeTarget = event.target.closest?.('.close-cart-button, [data-snug-cart-backdrop]');
        if (!closeTarget) return;
        event.preventDefault();
        closeCart();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.documentElement.classList.contains('open-minicart')) {
          closeCart();
        }
      });
    }
  }

  function initialiseSearch() {
    // Search submission is owned by snug-premium-search.js.
    document.querySelectorAll('.header_search form[role="search"]').forEach((form) => {
      form.dataset.snugSearchMenuReady = 'true';
    });
  }

  function initialiseAll() {
    document.querySelectorAll('.header .navigation.horizontal').forEach(initialise);
    initialiseHeaderActions();
    initialiseSearch();

    document.querySelectorAll('.header_search input[type="search"]').forEach((input) => {
      input.placeholder = 'Search';
      input.setAttribute('aria-label', 'Search products');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
